import { inject, Injectable } from '@angular/core';
import { ApiService } from './api-service';
import { map, Observable, switchMap, tap } from 'rxjs';
import { UserRole } from '../../shared/model/role';
import { IUser } from '../../shared/model/user';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  private apiService = inject(ApiService)

  loginUrl = 'api/auth/login';
  authUrl = 'api/auth/me'

  private TOKEN_KEY = 'token';

login(payload: any): Observable<any> {
  return this.apiService.post(this.loginUrl, payload).pipe(
    switchMap((loginResponse: any) => {
      localStorage.setItem('token', loginResponse.accessToken);

      return this.apiService.get(this.authUrl).pipe(
        map(authResponse => ({
          loginResponse,
          authResponse
        }))
      );
    })
  );
}

  auth():Observable<IUser> {
    return this.apiService.get(this.authUrl);
  }

  setToken(token: string): void {
    localStorage.setItem(this.TOKEN_KEY, token);
  }

  getToken(): string | null {
    return localStorage.getItem(this.TOKEN_KEY);
  }

  logout(): void {
    localStorage.removeItem(this.TOKEN_KEY);
  }

  isLoggedIn(): boolean {
    return !!this.getToken();
  }
}
